/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useCallback, useMemo, useState } from 'react';
import './NewDashboard.css';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import SolidGauge from 'highcharts/modules/solid-gauge';
import ChargingVsIdleChart from './ChargingVsIdleChart';
import EnergyTrendChart from './EnergyTrendChart';
import ChargingSessionTrend from './ChargingSessionTrend';
import OverAllUpTime from './OverAllUpTime';
import ChargingSession from './ChargingSession';
import DeepAIInsights from './DeepAIInsights';
import { fetchNewDashboardHeaderData, fetchNewDashboardRealTimeGunInfo, fetchNewDashboardConnectivityMediumData,getCurrentFiltersValues, getDashboardReducer, setFilterData, fetchChargerProductTypeReferenceData, getFilterSelectedValue, getReferenceDataReducer, fetchAlarmSeverityReferenceData, fetchNewDashboardFailedTransactionList, fetchNewDashboardFailedTransactionTopReasons, fetchIntervalRangeRefData, fetchNewDashboardAIInsightsList, fetchNewDashboardChargingSessionsList, fetchNewDashboardChargingSessionTrendList, fetchNewDashboardChargingVsIdleList, getAlarmReducer, fetchAlarmCardCountData, fetchNewDashboardAlarmSummaryList, fetchNewDashboardEnergyTrendList, fetchNewDashboardOverallUptimeList, fetchNewDashboardAttentionRequiredList,fetchNewDashboardEfficiencyTrendList, fetchNewDashboardReactiveEnergyConsumptionTrendList } from '../../rmsReduxStore/reduxExports';
import { AutoRefresh, FilterLayout, FilterProp, SidePopover, TableSubHeader, useAppDispatch, useAppSelector, useEffectOnce } from '../../globalUtils/globalExports';
import { formatNumberWithCommas, renderHeaderActionButtons } from '../../globalUtils/globalHooks';
import { Icon, IconWithTooltip } from '../../globalUtils/globalIcons';
import AttentionRequiredChargers from './AttentionRequiredChargers';
import FailedTransaction from './FailedTransaction';
import Overview from './Overview';
import { AlarmSummary } from '../componentExports';
import { setRedirectedStateForChargerFilters } from '../../rmsReduxStore/chargersRedux/chargerCreators';
import { useNavigate } from 'react-router-dom';
import { RectangularSkeleton } from '../../globalUtils/SkeletonDesign/SkeletonDesign';
import EfficiencyTrendChart from './EfficiencyTrendChart';
import ReactiveEnergyConsumptionTrendChart from './ReactiveEnergyConsumptionTrendChart';
import localStorageInstance from '../../rmsReduxStore/api-service/LocalStorageService';
import access from '../../auth/service/AccessControl';



const headerCardConstants = [
    {
        text: 'Customers',
        id: 'customers',
        redirectLink:'/customers',
        icon: 'newdashboard-customer dashboard-header-icon',
        tooltipText: '',
        bgcolor: '#D6D9FF',
        isAccessible: true
    },
    {
        text: 'Chargers',
        id: 'totalChargers',
        icon: 'newdashboard-charger dashboard-header-icon',
        redirectLink: '/manage-chargers',
        filterId:'all',
        tooltipText: '',
        bgcolor: '#FFE4CC',
        isAccessible: true
    },
    {
        text: 'Online Chargers',
        id: 'onlineChargers',
        icon: 'newdashboard-online-charger dashboard-header-icon',
        // redirectLink:'/customers'
        tooltipText: '',
        bgcolor: '#BEFFD5',
        filterId:'Online',
        redirectLink: '/manage-chargers',
        isAccessible: true
    },
    {
        text: 'Offline Chargers',
        id: 'offlineChargers',
        icon: 'newdashboard-offline-charger dashboard-header-icon',
        // redirectLink:'/customers'
        tooltipText: '',
        bgcolor: '#E6E6E6',
        cardClassName: '',
        filterId:'Offline',
        redirectLink: '/manage-chargers',
        isAccessible: true
    },
    {
        text: 'RMS Disable',
        id: 'rmsDisable',
        icon: 'newdashboard-offline-charger dashboard-header-icon',
        // redirectLink:'/customers'
        tooltipText: '',
        bgcolor: '#E6E6E6',
        cardClassName: '',
        filterId:'RmsDisable',
        redirectLink: '/manage-chargers',
        isAccessible: access?.newDashboard?.rmsDisabledCard()
    },
    // {
    //     text: 'CMS Connectivity',
    //     id: 'cmsConnectivity',
    //     icon: 'newDashboard__cms__connectivity__icon ',
    //     // redirectLink:'/customers'
    //     cardClassName: '',
    //     tooltipText: '',
    //     bgcolor: '#207D1133'
    // },
]

HighchartsMore(Highcharts);
SolidGauge(Highcharts);

const NewDashboard = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { newDashboardHeaderData, newDashboardRealTimeGunsInfo } = useAppSelector(getDashboardReducer);
    const { chargerProductTypeReferenceData ,customerReferenceData} = useAppSelector(getReferenceDataReducer);
    const { pulseAlarmLoader } = useAppSelector(getAlarmReducer);
    const [ customerFilterValue, setCustomerFilterValue ] = useState<IGeneralReferenceData>();
    const [ productFilterValue, setProductFilterValue ] = useState<IGeneralReferenceData>();
    const [aiInsightsVisible, setAiInsightsVisible] = useState(false);
    const [iFrameSrc,setIframeSrc] = useState('');
    const cardCount = headerCardConstants?.filter(card=>card?.isAccessible)?.length;
    const tilesCount = ['deepAIInsights','alarmSummary','failedTransaction','overAllUptime','attentionRequiredChargers','attentionRequiredChargersCards','chargingSessions','sessionTrend','chargingVsIdleTime']
    ?.filter(tile => {
        const isAccessible = access?.newDashboard?.tiles?.[tile]
        return typeof isAccessible === 'function' && isAccessible(); 
    })?.length;

    // useEffect(() => {
    //     window.addEventListener('beforeunload', newDashboardCleanUpStates);
    //     return (): void => {
    //         newDashboardCleanUpStates()
    //         window.removeEventListener('beforeunload', newDashboardCleanUpStates);
    //     }
    // }, [])

    // const newDashboardCleanUpStates = useCallback(() => {
    //       //: Partial<DashboardAction> 
    //     const dashboardAction = {
    //         type: dashboardTypes.CLEAR_NEW_DASHBOARD_DATA,
    //     }
    //     dispatch(dashboardAction);
    // }, [dispatch])

    useEffectOnce(()=>{
        dispatch(fetchChargerProductTypeReferenceData());
        dispatch(fetchAlarmSeverityReferenceData());
        dispatch(fetchIntervalRangeRefData());

        const customerFilter = getFilterSelectedValue('customer', 'global', true);
        setCustomerFilterValue(customerFilter);

        const productFilter = getFilterSelectedValue('productType', 'dashboardV2', false);
        setProductFilterValue(productFilter);

        // const dashboardCurrentFilters = getCurrentFiltersValues('dashboardV2');
        // dashboardCurrentFilters=dashboardCurrentFilters?.filter((item)=>item.key !=='productType')
        // fetchDashBoardData({ filters: dashboardCurrentFilters }, false)
    })

    const fetchFilterSelectedValues = (filterKey: string) => {
        return getFilterSelectedValue(filterKey, 'dashboardV2', false);
    }

    const getFilteredFilters = (widget: string, filters: any) => {
        const filterKeyList = ['customer', 'productType', 'offlineFiveDays']; //offlinefilter , 'offlineFiveDays'
        switch(widget) {
            case 'alarmStatistics':
            case 'alarmSummary':
                filterKeyList.push('severity');
                break;
            case 'failedTransaction':
                //This filter has been moved to its local screen
                // filterKeyList.push('failedTransactionRange');
                break;
            case 'chargingSessions':
                filterKeyList.push('sessionIntervalRange');
                break;
            case 'chargingSessionTrend':
                //This filter has been moved to its local screen
                // filterKeyList.push('sessionChargingIntervalRange');
                break;
            case 'chargingVsIdle':
                //This filter has been moved to its local screen
                // filterKeyList.push('idleChargingIntervalRange');
                break;
            case 'energyTrend':
                filterKeyList.push('energyConsumptionIntervalRange');
                break;
            case 'overallUptime':
                //This filter has been moved to its local screen
                // filterKeyList.push('uptimeIntervalRange');
                break;
            case 'attentionRequired':
                filterKeyList.push('keyType');
                break;
            case 'overview':
                break;
            case 'efficiencyTrend':
                filterKeyList.push('energyEfficiencyRange');
                break;
            case 'reactiveEnergyConsumptionTrend':
                filterKeyList.push('reactiveEnergyRange');
                break;
            default:
                break;
        }

        return filters.filter(item => filterKeyList.includes(item.key))
    }
    const  fetchAIInsightsData= (filters: any) => {
        const filterList = getFilteredFilters('aiInsights', filters);

        dispatch(fetchNewDashboardAIInsightsList({ filters: filterList }));

    }
    const fetchOverViewData = (filters: any) => {
        const filterList = getFilteredFilters('overview', filters);

        dispatch(fetchNewDashboardRealTimeGunInfo({ filters: filterList }));
        dispatch(fetchNewDashboardHeaderData({ filters: filterList }));
        dispatch(fetchNewDashboardConnectivityMediumData({filters: filterList}));
    }

    const fetchAlarmSummaryData = (filters: any) => {
        const filterList = getFilteredFilters('alarmSummary', filters)?.filter((filter) => filter.key !== 'productType');       // TODO: Remove this filtering

        dispatch(fetchAlarmCardCountData({ filters: filterList?.filter((item: any) => item?.key !== 'severity') || [] }));
        dispatch(fetchNewDashboardAlarmSummaryList({ filters: filterList, pageSize: 8, pageNumber: 1 }))
    }

    // const fetchAlarmStatisticsData = (filters: any) => {
    //     const filterList = getFilteredFilters('alarmStatistics', filters);
    //     dispatch(fetchAlarmListData({ sortBy: '', order: '', pageSize: 5, pageNumber: 1,filters: filterList?.filter((item)=>item?.key!='productType')}));
    //     dispatch(fetchNewDashboardAlarmSeverityInfo({ filters: filterList }));
    //     dispatch(fetchNewDashboardActiveAlarmInfo({ filters: filterList}));
    //     dispatch(fetchNewDashboardOutliersList({ filters: filterList }));
    //     dispatch(fetchNewDashboardAlarmClearInfo({ filters: filterList }));
    // }

    const fetchFailedTransactionData = (dashboardV2Filters:any,failedTransactionFilters: any) => {
        // const filterList = getFilteredFilters('failedTransaction', filters);
        const newDashboardScreenFilters = dashboardV2Filters.filter(item=>item.key ==='customer' || item.key ==='productType' || item.key ==='offlineFiveDays');
        const failedTransactionScreenFilters = failedTransactionFilters
        const combinedFilters = [...newDashboardScreenFilters,...failedTransactionScreenFilters ]
        dispatch(fetchNewDashboardFailedTransactionList({ filters: combinedFilters }));
        dispatch(fetchNewDashboardFailedTransactionTopReasons({ filters: combinedFilters }));
    }

    const fetchChargingSessionsData = (filters: any) => {
        const filterList = getFilteredFilters('chargingSessions', filters);
        const fetchTypeValues = getFilterSelectedValue('chargingSessionFetchType', 'dashboardV2', false);
        dispatch(fetchNewDashboardChargingSessionsList({ filters: filterList, fetchType: fetchTypeValues?.[0]?.value || 'energyConsumed' }));
    }

    const fetchChargingSessionTrendData = (dashboardV2Filters:any,chargingSessionTrendFilters: any) => {
        // const filterList = getFilteredFilters('chargingSessionTrend', filters);
        const newDashboardScreenFilters = dashboardV2Filters.filter(item=>item.key ==='customer' || item.key ==='productType' || item.key ==='offlineFiveDays');
        const chargingSessionTrendScreenFilters = chargingSessionTrendFilters
        const combinedFilters = [...newDashboardScreenFilters,...chargingSessionTrendScreenFilters ]
        dispatch(fetchNewDashboardChargingSessionTrendList({ filters: combinedFilters }));
    }

    const fetchChargingVsIdleData = (dashboardV2Filters:any,chargingVsIdleFilters: any) => {
        // const filterList = getFilteredFilters('chargingVsIdle', filters);
        const newDashboardScreenFilters = dashboardV2Filters.filter(item=>item.key ==='customer' || item.key ==='productType' || item.key ==='offlineFiveDays');
        const chargingVsIdleScreenFilters = chargingVsIdleFilters
        const combinedFilters = [...newDashboardScreenFilters,...chargingVsIdleScreenFilters]
        dispatch(fetchNewDashboardChargingVsIdleList({ filters: combinedFilters }));
    }

    const fetchEnergyTrendData = (filters: any) => {
        const filterList = getFilteredFilters('energyTrend', filters);

        dispatch(fetchNewDashboardEnergyTrendList({ filters: filterList }));
    }

    const fetchEfficiencyTrendData = (filters: any) => {
        const filterList = getFilteredFilters('efficiencyTrend', filters).filter(item=>item.key!='productType');

        dispatch(fetchNewDashboardEfficiencyTrendList({ filters: filterList }));
    }
    const fetchReactiveEnergyConsumptionTrendData = (filters: any) => {
        const filterList = getFilteredFilters('reactiveEnergyConsumptionTrend', filters).filter(item=>item.key!='productType');

        dispatch(fetchNewDashboardReactiveEnergyConsumptionTrendList({ filters: filterList }));
    }

    const fetchOverallUptimeData = (dashboardV2Filters:any,overallUptimefilters: any) => {
        // const filterList = getFilteredFilters('overallUptime', filters);
        const newDashboardScreenFilters = dashboardV2Filters.filter(item=>item.key ==='customer' || item.key ==='productType' || item.key ==='offlineFiveDays');
        const overAllUptimeScreenFilters = overallUptimefilters
        const combinedFilters = [...newDashboardScreenFilters,...overAllUptimeScreenFilters]

        dispatch(fetchNewDashboardOverallUptimeList({ filters: combinedFilters }));
    }

    const fetchAttentionRequiredData = (filters: any) => {
        const filterList = getFilteredFilters('attentionRequired', filters);

        dispatch(fetchNewDashboardAttentionRequiredList({ filters: filterList }));
    }

    const handleOfflineClick = (filters: any) => {
        fetchDashBoardData(filters, false);
    }

    const fetchDashBoardData = useCallback((val, showLoader): void => {
        
        if(access?.newDashboard?.tiles?.overview()) fetchOverViewData(val?.filters);
        const failedTransactionLocalFilters = getCurrentFiltersValues('failedTransaction',true);
        if(access?.newDashboard?.tiles?.failedTransaction())fetchFailedTransactionData(val?.filters,failedTransactionLocalFilters);
        if(access?.newDashboard?.tiles?.deepAIInsights())fetchAIInsightsData(val?.filters);
        if(access?.newDashboard?.tiles?.chargingSessions())fetchChargingSessionsData(val?.filters);
        const chargingSessionTrendFilters = getCurrentFiltersValues('chargingSessionTrend',true);
        if(access?.newDashboard?.tiles?.sessionTrend())fetchChargingSessionTrendData(val?.filters,chargingSessionTrendFilters);
        const chargingVsIdleFilters = getCurrentFiltersValues('chargingVsIdle',true);
        if(access?.newDashboard?.tiles?.chargingVsIdleTime())fetchChargingVsIdleData(val?.filters,chargingVsIdleFilters);
        if(access?.newDashboard?.tiles?.alarmSummary())fetchAlarmSummaryData(val?.filters);
        if(access?.newDashboard?.tiles?.energyConsumption())fetchEnergyTrendData(val?.filters);
        if(access?.newDashboard?.tiles?.efficiencyTrend())fetchEfficiencyTrendData(val?.filters);
        if(access?.newDashboard?.tiles?.reactiveEnergyTrend())fetchReactiveEnergyConsumptionTrendData(val?.filters);
        if(access?.newDashboard?.tiles?.attentionRequiredChargers())fetchAttentionRequiredData(val?.filters);
        const overallUptimeLocalFilters = getCurrentFiltersValues('overallUptime',true);
        if(access?.newDashboard?.tiles?.overAllUptime())fetchOverallUptimeData(val?.filters,overallUptimeLocalFilters)

    }, [fetchOverViewData, fetchFailedTransactionData, fetchAIInsightsData, fetchChargingSessionsData, fetchChargingSessionTrendData, fetchChargingVsIdleData, fetchAlarmSummaryData, fetchEnergyTrendData, fetchOverallUptimeData, fetchAttentionRequiredData,fetchEfficiencyTrendData,fetchReactiveEnergyConsumptionTrendData,access]);

    const handleFilterDataChange = useCallback(async (val, filterKey, isGlobal) => {
        const res = await setFilterData(val, filterKey, 'dashboardV2', 'SET', isGlobal ? isGlobal : false)(dispatch)
        if (res?.message === 'Action dispatched successfully') {
            fetchDashBoardData({ filters: res?.filters }, false)
        }
    }, [dispatch, setFilterData, fetchDashBoardData])
    
    // const handleCustomerFilterChange = useCallback(async (val) => {
    //     const res = await setFilterData(val, 'customer', '', 'SET', true)(dispatch)
    //     if (res?.message === 'Action dispatched successfully') {
    //         fetchDashBoardData({ filters: res?.filters }, false)
    //     }
    // }, [dispatch, setFilterData, fetchDashBoardData])

    // const handleProductFilterChange = useCallback(async (val) => {
    //     const res = await setFilterData(val, 'productType', 'dashboardV2', 'SET', false)(dispatch)
    //     if (res?.message === 'Action dispatched successfully') {
    //         fetchDashBoardData({ filters: res?.filters }, false)
    //     }
    // }, [dispatch, setFilterData, fetchDashBoardData])

    const handleHeaderCardClick = useCallback(async (e, card) => {
        const  offlinefiltersAppliedValue= await getFilterSelectedValue('offlineFiveDays','dashboardV2',false)
        if(offlinefiltersAppliedValue && offlinefiltersAppliedValue[0].value==='true' && (card.text==='Chargers' ||card.text==='Offline Chargers' )) return;
        e?.stopPropagation();
        // if (card?.id === 'cmsConnectivity') 
        //     return;
        const currentCustomerFilterValue = await getFilterSelectedValue('customer','',true);
        
        const customersToInclude = currentCustomerFilterValue && currentCustomerFilterValue.length > 0 ? currentCustomerFilterValue : customerReferenceData?.filter(customer=> customer?.customerType==='External' &&  customer?.name!=='All')?.map(customer=>({
            id: customer?.id,
            value: customer?.value,
            label: customer?.label,
            name: customer?.name
         }))
         await setFilterData(null, '', 'chargers', 'CLEAR', false)(dispatch);
         setRedirectedStateForChargerFilters(true, card?.filterId, null, null, 'newDashboard',customersToInclude)(dispatch)
            .then((res) => {
            if (res === 'Action dispatched successfully') {
                navigate(card?.redirectLink, {
                state: { chargerStatusId: card?.filterId }
                });
            }
            })
            .catch((error) => {
            console.error('Error dispatching action:', error); // Handle error
            });
    }, [dispatch, setRedirectedStateForChargerFilters, navigate])

    const onRefeshCallBack = useCallback(() => {
        const dashboardCurrentFilters = getCurrentFiltersValues('dashboardV2');
        fetchDashBoardData({ filters: dashboardCurrentFilters }, false)
    }, [getCurrentFiltersValues, fetchDashBoardData])

    const dashboardFilterProps: FilterProp[] = useMemo(() => {
        return [
          {
            filterLabel: 'Product Type',
            filterType: 'dropdown',
            filterId: 'chargerType',
            filterDropdownProps: {
              selectValue: getFilterSelectedValue('productType', 'dashboardV2', false),
              selectOptions: chargerProductTypeReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'productType', false)
              },
              selectDropDownId: 'dashboard-charger-type-filter-dropdown',
              isMultiSelect: true,
              renderToBody:true
            }
            
          }
        ]
      }, [chargerProductTypeReferenceData, getFilterSelectedValue, handleFilterDataChange])

      const headerActionBtns = renderHeaderActionButtons({
        actionBtns:
          [
            {
              id: 'ai_insights_btn',
              isAccessible: access?.aiInsightsAccess?.view(),
              // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
              headerActionBtnClick: (event): void => {
            //   const customerSelected = getFilterSelectedValue('customer', 'dashboardV2', true);
            //   const productTypeSelected = getFilterSelectedValue('productType', 'dashboardV2', false);
            //   const response = {
            //     userId:localStorageInstance.fetchUser()?.id,
            //     customer:customerSelected?.filter(item =>item?.id!=='all')?.map(item=>
            //         item?.id
            //     ),
            //     productType:productTypeSelected?.filter(item=>item?.id!=='all')?.map(item=>
            //         item?.id
            //     )
            //   }
            //     const jsonString = JSON.stringify(response);
            //     const base64Encoded = btoa(jsonString); 
            //     const token = encodeURIComponent(base64Encoded);
                const token = localStorageInstance?.getAccessToken();
                setIframeSrc(`https://spinrms.com/streamlit/?token=${token}`);
                setAiInsightsVisible(true);
              },
            },
          ],
      })
      const handleFiltersClosePopOver = (): void => {
        setAiInsightsVisible(false);
      }
    return (
        <div className="dashboard new-dashboard-container">
            <div className="new-dashboard-header-container">
                <div className='new-dashboard-header-wrap'>
                    <div className='new-dashboard-header-left'>
                        <div className='new-dashboard-header-heading'>Dashboard</div>
                        <div className="app__dashboard__header-left">
                            <div className="app__dashboard__header-bottom-auto-refresh-wrap">
                                <AutoRefresh
                                    refreshDate={newDashboardHeaderData?.lastRefreshTime ?? ''}
                                    containerClassName="dashboard__auto__refresh__component"
                                    onRefreshCallback={onRefeshCallBack}
                                    pathName="/newDashboard"
                                    refreshLocation={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-header-stats">
                        <div className="app__dashboard__header-right">
                            <FilterLayout requiredReferenceDataCallbacks={['chargerType']}
                            filters={dashboardFilterProps} handleFilterDataChange={handleFilterDataChange} screen='newDashboard' />
                        </div>
                        <div className='ai-insights-buttons'>
                        <TableSubHeader headerActionBtns={headerActionBtns} />
                            {aiInsightsVisible && <SidePopover
                                id={'manage__ai_insight_side_popper'}
                                open={aiInsightsVisible}
                                containerClassName='manage__ai_insight_side_popper'
                                handleClose={handleFiltersClosePopOver}
                                headerText={'AI Insights'}
                                // eslint-disable-next-line react/no-children-prop
                                children={
                                    <>
                                    <iframe
                                      src={iFrameSrc} // Replace with your desired website URL
                                      width="100%"
                                      height="100%"
                                      style={{ border: 'none' }}
                                      title="External Website"
                                    ></iframe>
                                  </>
                                }
                            />
                            }
                        </div>
                    </div>
                </div>
                <div className="new__dashboard__header-cards" style={{gridTemplateColumns: `repeat(${cardCount}, 1fr)`}}>
                    {headerCardConstants?.map((card, index) => {
                        if(!card.isAccessible)return;
                        return ( 
                            <div
                                key={'card' + index}
                                className={'new__dashboard__header-card ' + card?.id}
                            >
                                { !newDashboardHeaderData ?
                                    <RectangularSkeleton  skeletonContainerClassName='' />
                                :<>
                                <div style={{ position: 'absolute', zIndex: 999, scale: 0.9, right: 0 }}>
                                <Icon
                                containerClassName="card__background-icon"
                                iconClassName="newdashboard-header-icon"
                                />
                                </div>
                                    
                                 <div
                                    key={index}
                                    className={'card ' + card?.cardClassName}
                                    style={{ backgroundColor: card?.bgcolor }}
                                    onClick={async (e) => await handleHeaderCardClick(e, card)}
                                >
                                    <div className="card__header">
                                        <Icon
                                            containerClassName={'card__header__icon'} iconClassName={card?.icon}
                                        />
                                        <div className="card__header__text">
                                            {card?.text}
                                        </div>
                                            { card?.tooltipText && card?.tooltipText?.length>0 && <IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={card?.tooltipText} containerClassName='charger__health__status-header-info' />}
                                    </div>
                                    <div className="card__footer__wrap">
                                        <div className="card__header__count">
                                        {
                                        newDashboardHeaderData && newDashboardHeaderData[card?.id] ? formatNumberWithCommas(newDashboardHeaderData[card?.id]) : newDashboardRealTimeGunsInfo && newDashboardRealTimeGunsInfo[card?.id] ? formatNumberWithCommas(newDashboardRealTimeGunsInfo[card?.id]) : 0}
                                        </div>
                                    </div>
                                </div>
                                </>


                                }
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className='dashboard-body-container'>

                {
                    access?.newDashboard?.tiles?.overview() && <div className='new__dashboard__row new__dashboard__widget new-dashboard-overview-container'>
                        <Overview handleFilter={fetchOverViewData} getFilterValue={fetchFilterSelectedValues} handleOfflineClick={handleOfflineClick} />
                    </div> 
                }

                {/* <div className='new__dashboard__row ai-insights-active-alarm-container'> */}
                    {
                        access?.newDashboard?.tiles?.deepAIInsights() && <div className='new__dashboard__widget dashboard-ai-insights-container'>
                            {/* <AIInsightsCarousal/> */}
                            <DeepAIInsights />
                        </div>
                    }
                    {
                        access?.newDashboard?.tiles?.alarmSummary() && <div className={`new__dashboard__widget dashboard-active-alarm-container ${tilesCount % 2 !== 0 ? 'span-10' : ''}`}>
                            <AlarmSummary loader={pulseAlarmLoader} isNewDashBoard={true} getFilterValue={fetchAlarmSummaryData} />
                        </div>
                    }
                {/* </div> */}

                {/* <div className='new__dashboard__row'>  */}
                    {
                        access?.newDashboard?.tiles?.overAllUptime() && <div className='new__dashboard__widget overall-uptime-container'>
                            <OverAllUpTime handleFilter={fetchOverallUptimeData} getFilterValue={fetchFilterSelectedValues}/>
                        </div>
                    }

                    {
                        access?.newDashboard?.tiles?.failedTransaction() && <div className='new__dashboard__widget failed-txn-container'>
                            <FailedTransaction handleFilter={fetchFailedTransactionData} getFilterValue={fetchFilterSelectedValues} />
                        </div>
                    }
                {/* </div>  */}

                {/* <div className='new__dashboard__row'> */}
                {   access?.newDashboard?.tiles?.attentionRequiredChargers() && <div className='new__dashboard__widget action-required-container'>
                        <AttentionRequiredChargers handleFilter={fetchAttentionRequiredData} getFilterValue={fetchFilterSelectedValues} />
                    </div>
                }
                {
                    access?.newDashboard?.tiles?.chargingSessions() && <div className='new__dashboard__widget charging-session-container'>
                        <ChargingSession handleFilter={fetchChargingSessionsData} getFilterValue={fetchFilterSelectedValues}/>
                    </div>
                }
                {/* </div> */}
                
                {/* <div className='new__dashboard__row'> */}
                {
                    access?.newDashboard?.tiles?.sessionTrend() && <div className='new__dashboard__widget charging-session-trend-container'>
                        <ChargingSessionTrend handleFilter={fetchChargingSessionTrendData} getFilterValue={fetchFilterSelectedValues}/>
                    </div>
                }
                {
                    access?.newDashboard?.tiles?.chargingVsIdleTime() && <div className='new__dashboard__widget charging-idle-time-container'>
                        <ChargingVsIdleChart handleFilter={fetchChargingVsIdleData} getFilterValue={fetchFilterSelectedValues}/>
                    </div>
                }
                {/* </div> */}

                {/* <div className='new__dashboard__row'> */}
                   {
                        access?.newDashboard?.tiles?.energyConsumption() && <div className='new__dashboard__widget energy-consumption-container'>
                            <EnergyTrendChart handleFilter={fetchEnergyTrendData} getFilterValue={fetchFilterSelectedValues}/>
                        </div>
                   }

                    {
                        !access?.isOrgTypeCustomer() ? 
                        <>
                            {
                                access?.newDashboard?.tiles?.efficiencyTrend() && <div className='new__dashboard__widget chargers-efficiency-container'>
                                    <EfficiencyTrendChart handleFilter={fetchEfficiencyTrendData} getFilterValue={fetchFilterSelectedValues}/>
                                </div>
                            }

                            {
                                access?.newDashboard?.tiles?.reactiveEnergyTrend() && <div className='new__dashboard__widget chargers-efficiency-container'>
                                    <ReactiveEnergyConsumptionTrendChart handleFilter={fetchReactiveEnergyConsumptionTrendData} getFilterValue={fetchFilterSelectedValues}/>
                                </div>
                            }
                        </>:
                        <></>
                    }

                    {/* <div className='utlization-percent-container'>
                        <UtilizationTrendChart/>
                    </div> */}
                {/* </div> */}

                {/* <div className='dashboard-charging-idle-time-chloropleth-map-container-container'>
                    <div className='chloropleth-map-container'>
                        <ChloroplethMap/>
                    </div>
                    <div className='peak-usage-container'>
                        <PeakUsage />
                    </div>
                </div> */}
                {/* Row 1 */}
                {/* <div className='new__dashboard__widget__container_row2'>
                    <div className='ai-insights-container'>
                        <AIInsightsCarousal />
                    </div>
                    <div className='dashboard-alarm-statistics-container'>
                        <AlarmStatistics handleFilter={fetchAlarmStatisticsData} getFilterValue={fetchFilterSelectedValues} />
                    </div>
                </div> */}

                {/* Row 2 */}
                {/* <div className='new__dashboard__widget__container'>
                    <div className='new-dashboard-alarm-summary'>
                        <AlarmSummary loader={false} isNewDashBoard={true} />
                    </div>
                    
                    <div className='failed-transaction-analysis'>
                        <FailedTransaction handleFilter={fetchFailedTransactionData} getFilterValue={fetchFilterSelectedValues} />
                    </div>

                    <div className='new__dashboard__charger__status__wrap'>
                        <ChargerStatus />
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default NewDashboard;
